import {
  AutoSelectDatesPanel,
  DatePickerInput,
} from '@wajeez-web/components/ui';
import { Dropdown, Button } from 'antd';
import { useEffect, useState } from 'react';
import { BsList } from 'react-icons/bs';
import { classNames } from '@wajeez-web/core/utils';
import { useScrollPosition } from '@wajeez-web/core/utils';
export interface FiltersSectionProps {
  dates: Date[];
  setDates: (dates: Date[]) => void;
  filter?: JSX.Element;
  smFilter?: JSX.Element;
  autoSelectDatesDirection?: 'vertical' | 'horizontal';
}

const FiltersSection = ({
  dates,
  setDates,
  filter,
  smFilter,
  autoSelectDatesDirection,
}: FiltersSectionProps) => {
  const scrollPosition = useScrollPosition();
  return (
    <div
      className={classNames(
        scrollPosition > 0 ? ' shadow-lg border' : 'shadow-none',
        'sticky top-0 z-10 bg-white  py-2'
      )}
    >
      <div className="flex flex-col md:flex-row space-y-2 justify-between w-full items-end  md:items-center ">
        {autoSelectDatesDirection === 'horizontal' && (
          <div className=" hidden md:block">
            {' '}
            <AutoSelectDatesPanel
              selectedDates={dates}
              direction="horizontal"
              setInputDates={(dates) => {
                setDates(dates);
              }}
              oldestDate={new Date(Date.UTC(2018, 0, 1))}
            />
          </div>
        )}{' '}
        <div>{filter}</div>
        <div className=" flex bg-white border p-1 space-s-2 items-center ">
          <div
            className={`${
              autoSelectDatesDirection === 'vertical'
                ? 'block'
                : 'block md:hidden'
            }`}
          >
            {' '}
            <Dropdown
              dropdownRender={() => (
                <div className="bg-white border">
                  <AutoSelectDatesPanel
                    setInputDates={(dates) => {
                      setDates(dates);
                    }}
                    oldestDate={new Date(Date.UTC(2018, 0, 1))}
                  />
                </div>
              )}
              placement="bottomLeft"
              arrow
            >
              <Button
                className="flex items-center justify-center"
                type="text"
                icon={<BsList className="h-5 w-5" />}
              />
            </Dropdown>
          </div>
          <DatePickerInput
            color={' text-textPrimary border-0 focus:border-none'}
            value={dates[0].toString() || null}
            onChange={(name, value) => {
              setDates([new Date(value), dates[1]]);
            }}
            name="fromDate"
            maxDate={dates[1]}
          />
          <div className="flex items-center justify-center">
            <span className="text-gray-500">-</span>
          </div>
          <DatePickerInput
            minDate={dates[0]}
            value={dates[1].toString() || ''}
            onChange={(_, value) => {
              setDates([dates[0] || '', new Date(value)]);
            }}
            name="toDate"
            color={
              ' text-textPrimary border-none border-r-0 border-l-0 focus:border-none focus:'
            }
          />
        </div>
        <div className="block md:hidden">{smFilter}</div>
      </div>
    </div>
  );
};
export default FiltersSection;
